module.exports = __webpack_public_path__ + "img/RobertRice.e0b38403.jpg";